import { useEffect } from 'react';

// utils
import { setDomainCookie } from '../../../../utils/cookie';
import { updateVpPDP } from '../tracking/updateViewedProducts';

// types
import type { Product } from '@virginexperiencedays/products';

const RECENTLY_VIEWED_STORAGE_KEY = 'vp';
const RECENTLY_VIEWED_COOKIE_KEY = 'recently_viewed_products';

/**
 * Hook: updates recently viewed products (stored as 'vp') in both local
 * storage and a main-domain cookie (to share with subdomains such as My
 * Account).
 */
export const useRecentlyViewed = (product: Product) => {
  useEffect(() => {
    if (typeof window?.localStorage === 'undefined') return;

    // take current local storage
    const current = window.localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY);
    const now = Number(new Date(Date.now()));

    // add the current product into the arrays
    const { localStorageProducts, cookieProductIds } = updateVpPDP(product, now, current);

    // save back into local storage and cookie
    window.localStorage.setItem(RECENTLY_VIEWED_STORAGE_KEY, localStorageProducts);
    setDomainCookie(RECENTLY_VIEWED_COOKIE_KEY, cookieProductIds);
  }, [product]);
};
